import React, { useEffect, useState } from 'react';
import { Form, Input, message, Modal } from 'antd';
import { KnowledgeItemVo, updateItem } from '@/api/knowledgeBase';

export interface EditItemProp {
  data: KnowledgeItemVo;
  updateFn: () => void;
  onCancel: () => void;
}

const EditItem = ({ data, updateFn, onCancel }: EditItemProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data?.id) {
      form.setFieldsValue({
        name: data.name,
        rawContent: data.rawContent || '',
      });
    }
  }, [data?.id, form, data]);

  const onFinish = () => {
    form.validateFields().then(values => {
      setLoading(true);
      updateItem({
        id: data.id,
        name: values.name,
        content: values.rawContent,
      })
        .then(() => {
          message.success('保存成功');
          onCancel();
          updateFn();
        })
        .catch((err: any) => {
          message.error(err.message || '保存失败');
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <Modal
      title="编辑条目"
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      width={800}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="条目名称" rules={[{ required: true, message: '请输入条目名称' }]}>
          <Input placeholder="请输入条目名称" />
        </Form.Item>
        <Form.Item name="rawContent" label="内容" rules={[{ required: true, message: '请输入内容' }]}>
          <Input.TextArea rows={15} placeholder="请输入条目内容" />
        </Form.Item>
        <Form.Item>
          <div style={{ color: '#666', fontSize: 12 }}>
            条目类型：{data.kind === 'config' ? '配置文档' : 'RAG 文档'}
            {data.kind === 'config' && '（支持 JSON 格式配置，修改后将重新解析并替换配置行）'}
            {data.kind === 'rag' && '（修改后将重新分块并替换原有分块）'}
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditItem;
